import { useTheme } from "@mui/material";
import React from "react";

type StateType =
  | "add"
  | "update"
  | "updateDetails"
  | "updateDashboardDetails"
  | "publish";
interface EditDetailsProps {
  data?: any;
  onClose: () => void;
  setUpdatedKbText?: any;
  setAddKbText?: any;
  onUpdate?: () => void;
  onAdd?: () => void;
  onPublish?: () => void;
  state?: StateType;
  loader?: boolean;
}

const iconMap = {
  add: {
    buttonIcon: "bi-plus",
    buttonText: "Add",
    titleIcon: "bi-plus-square",
  },
  update: {
    buttonIcon: "bi-pencil-square",
    buttonText: "Update",
    titleIcon: "bi-pencil-square",
  },
  updateDetails: {
    buttonIcon: "bi-pencil-square",
    buttonText: "Update",
    titleIcon: "bi-exclamation-triangle",
  },
  updateDashboardDetails: {
    buttonIcon: "bi-pencil-square",
    buttonText: "Update",
    titleIcon: "bi-exclamation-triangle",
  },
  publish: {
    buttonIcon: "bi-pencil-square",
    buttonText: "Publish",
    titleIcon: "bi-exclamation-triangle",
  },
};

const EditDetails: React.FC<EditDetailsProps> = ({
  data,
  onClose,
  setUpdatedKbText,
  setAddKbText,
  onUpdate,
  onAdd,
  onPublish,
  state = "add",
  loader,
}) => {
  const configs = iconMap[state];

  const theme = useTheme();
  const color = theme.palette.mode;

  return (
    <div
      data-bs-theme={`light`}
      className="modal fade show d-block customkb-modal"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      aria-labelledby="exampleModalLabel"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ display: "flex" }}>
              {!loader && (
                <i className={`bi ${configs.titleIcon} me-2 text-primary`}></i>
              )}
              {state === "add" && !loader && (
                <p style={{ margin: 0 }}>Add New KB</p>
              )}
              {state === "update" && !loader && (
                <>
                  <p style={{ margin: 0 }}>Update Custom KB - </p>
                  <strong>{data.number}</strong>
                </>
              )}
              {state === "updateDetails" && !loader && (
                <p style={{ margin: 0 }}>Are you sure you want to update? </p>
              )}
              {state === "updateDashboardDetails" && !loader && (
                <p style={{ margin: 0 }}>Are you sure you want to update? </p>
              )}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body" style={{ margin: 0 }}>
            <div>
              {state !== "updateDetails" && state !== "publish" && !loader && (
                <label htmlFor="editDesc" className="form-label">
                  Description <span className="text-danger">*</span>
                </label>
              )}

              {/* {state !== "publish" && !loader && (
                <label htmlFor="editDesc" className="form-label">
                  Description <span className="text-danger">*</span>
                </label>
              )} */}

              {state === "add" ? (
                !loader ? (
                  <textarea
                    className="form-control"
                    name=""
                    id="editDesc"
                    rows={4}
                    onChange={(e) => setAddKbText(e.target.value)}
                  ></textarea>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="bi bi-hourglass-split text-primary rotate-center"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <div>Please Wait. While we are Adding KB.</div>
                  </div>
                )
              ) : (
                <></>
              )}

              {state === "update" ? (
                !loader ? (
                  <textarea
                    className="form-control"
                    name=""
                    id="editDesc"
                    rows={4}
                    defaultValue={data.content}
                    onChange={(e) => setUpdatedKbText(e.target.value)}
                  ></textarea>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="bi bi-hourglass-split text-primary rotate-center"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <div>Please Wait. While we are updating.</div>
                  </div>
                )
              ) : (
                <></>
              )}

              {state === "updateDetails" ? (
                !loader ? (
                  <div>
                    NOTE : Updating Enriched Data will overide Knowledge Article
                    Summarization, please be careful before writing anything in
                    the Enriched Data
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="bi bi-hourglass-split text-primary rotate-center"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <div>Please Wait. While we are updating.</div>
                  </div>
                )
              ) : (
                <></>
              )}

              {state === "updateDashboardDetails" ? (
                !loader ? (
                  <textarea
                    className="form-control"
                    name=""
                    id="editDesc"
                    rows={4}
                    onChange={(e) => setUpdatedKbText(e.target.value)}
                  ></textarea>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="bi bi-hourglass-split text-primary rotate-center"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <div>Please Wait. While we are updating.</div>
                  </div>
                )
              ) : (
                <></>
              )}

              {state === "publish" ? (
                !loader ? (
                  <p style={{ margin: 0, textAlign: 'center' }}>
                    Are you sure you want to Publish?{" "}
                  </p>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="bi bi-hourglass-split text-primary rotate-center"
                      style={{ fontSize: "40px" }}
                    ></i>
                    <div>Please Wait. While we are Publishing.</div>
                  </div>
                )
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="modal-footer" style={{ justifyContent: "end" }}>
            {!loader && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                <i className="bi bi-x-circle me-1"></i> Cancel
              </button>
            )}

            {state === "add" && !loader && (
              <button type="button" className="btn btn-primary" onClick={onAdd}>
                <i className="bi bi-plus me-1"></i> {configs.buttonText}
              </button>
            )}

            {state === "update" && !loader && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={onUpdate}
              >
                <i className="bi bi-check-circle me-1"></i> {configs.buttonText}
              </button>
            )}

            {state === "updateDetails" && !loader && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={onUpdate}
              >
                <i className="bi bi-check-circle me-1"></i> {configs.buttonText}
              </button>
            )}

            {state === "updateDashboardDetails" && !loader && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={onUpdate}
              >
                <i className="bi bi-check-circle me-1"></i> {configs.buttonText}
              </button>
            )}

            {state === "publish" && !loader && (
              <button
                type="button"
                className="btn btn-success"
                onClick={onPublish}
              >
                <i className="bi bi-check-circle me-1"></i> {configs.buttonText}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditDetails;
